<div class="background"></div>

<div class="content">
  <div class="title">Ottieni il tuo Buono</div>

  <div class="coupon-section" *ngIf="codiceBuono; else noBuono">
    <div class="buono-info">
      <p>Buono: <strong>{{ codiceBuono }}</strong></p>
    </div>

    <form (ngSubmit)="onSubmit()" class="coupon-form">
      <div class="form-group">
        <label for="email">Inserisci la tua email</label>
        <input
          type="email"
          id="email"
          [(ngModel)]="email"
          name="email"
          placeholder="tuaemail@esempio.com"
          required
          [disabled]="isLoading"
        />
      </div>

      <button type="submit" class="submit-button" [disabled]="isLoading || !email">
        <span *ngIf="!isLoading">Invia Coupon</span>
        <span *ngIf="isLoading">Invio in corso...</span>
      </button>
    </form>

    <div class="message" *ngIf="message" [class.error]="isError" [class.success]="isSuccess">
      {{ message }}
    </div>
  </div>

  <ng-template #noBuono>
    <div class="error-section">
      <p>Nessun codice buono specificato.</p>
      <p>Assicurati di usare il link corretto con il parametro <code>?buono=CODICE</code></p>
    </div>
  </ng-template>
</div>
